// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__QL3Xn","author":"Table_author__13PwQ","authorImage":"Table_authorImage__1PNpx","unreadRow":"Table_unreadRow__2f73-"};